import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import { ImageOff } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { useProductGalleryEmptyStateStyles } from './productGalleryEmptyState.styles';

const ProductGalleryEmptyState = () => {
  const { translate } = useTranslation();
  const { classes } = useProductGalleryEmptyStateStyles();

  return (
    <div className={classes.root}>
      <Icon icon={ImageOff} size="lg" className={classes.icon} />

      <Typography variant="h5" color="text.disabled" sx={{ fontWeight: 400 }}>
        {translate(LangEnum.GLOBAL_NO_PHOTO_AVAILABLE)}
      </Typography>
    </div>
  );
};

export default ProductGalleryEmptyState;
